import styles from './Banner.module.scss';
import Content from '../Content/Content';
import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import { Button as BaseButton } from '@ariakit/react';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const Banner = ({ details, color, icon, handleClose }) => (
  <div className={classNames(styles.container, styles[color])}>
    <div className={styles.detailContainer}>
      <FontAwesomeProIcon
        className={styles.icon}
        icon={icon}
        role="presentation"
        type="regular"
      />
      <Content className={styles.content} noSpacing role="alert" withParser>
        {details}
      </Content>
    </div>
    <BaseButton
      aria-label="Infobar schließen"
      className={styles.closeButton}
      onClick={handleClose}
    >
      <FontAwesomeProIcon
        className={styles.closeIcon}
        icon="times"
        role="presentation"
      />
    </BaseButton>
  </div>
);

Banner.propTypes = {
  color: PropTypes.oneOf(['red', 'blue', 'grey']).isRequired,
  details: PropTypes.string.isRequired,
  handleClose: PropTypes.func,
  icon: PropTypes.string.isRequired,
};

export default Banner;
